import { Skeleton } from "@apex/component-library";
import { Box, Stack } from "@chakra-ui/react";

export interface AuxSkeletonProps {}

const AuxSkeleton = (props: AuxSkeletonProps) => {
  return (
    <Box p={4}>
      <Stack spacing={4}>
        <Skeleton w="100%" maxW="200px" h={6} />
        <Skeleton w="100%" maxW="300px" h={4} />
        <Skeleton w="100%" maxW="300px" h={6} />
        <Skeleton w="100%" maxW="200px" h={6} />
      </Stack>
    </Box>
  );
};

export default AuxSkeleton;
